module.exports = __webpack_public_path__ + "img/Tessellate24.2aea028a.jpg";